// ProfileInfoUserHashtags.js
'use strict';
import { connect } from 'react-redux';

import ProfileInfoUserHashtags from '../component/ProfileInfoUserHashtags.jsx';
import getUserData from '../selector/getUserData.js';
import { HASHTAG_FEED_USER } from '../RemoteConfigKeys.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';

const mapStateToProps = (state, { userId }) => {
  const hashtagFeedUser = getRemoteConfigData(state, HASHTAG_FEED_USER);

  return {
    hashtagFeedUser,
    hashtags: getUserData(state, userId, 'hashtags'),
  };
};

export default connect(mapStateToProps, null)(ProfileInfoUserHashtags);
